import React, { useState } from "react";
import { Container, Card, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../../context/appContext";
import { useMutation } from "@apollo/client";
import UserDetails from "./sections/UserDetails";
import { toast } from "react-toastify";
import { CREATE_USERS_MUTATION } from "../../../graphql/mutations";
import { isAdmin, isProd } from "../../../utils/permissions";
import { allowedProdTenants } from "../../../utils/permissions";

const AddUserPage = ({ isLoading, isError, tenants, env, handleEnvChange, onUserCreate }) => {
  const { user } = useAppContext();

  const isProdNotAdmin = isProd(env) && !isAdmin(user);

  const filteredTenants = isProdNotAdmin ? tenants?.filter((tenant) => allowedProdTenants.includes(tenant?.name.toLowerCase())) : tenants;

  const [formData, setFormData] = useState({
    email: "",
    firstName: "",
    lastName: "",
    roleName: "",
    tenantId: "",
    tenantName: "",
    gcpMemberId: null
  });

  const navigate = useNavigate();
  const [createUsers, { loading: mutationLoading }] = useMutation(CREATE_USERS_MUTATION);

  const handleFormChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const gcpMemberIdValue = formData.gcpMemberId ? parseInt(formData.gcpMemberId, 10) : null;

      const { data } = await createUsers({
        variables: {
          usersDataInput: [
            {
              email: formData.email,
              firstName: formData.firstName,
              lastName: formData.lastName,
              roleName: formData.roleName,
              tenantId: formData.tenantId,
              memberId: gcpMemberIdValue
            }
          ]
        }
      });

      const createdIds = data?.createUsers;
      const firstId = Array.isArray(createdIds) && createdIds.length > 0 ? createdIds[0] : null;

      if (formData.tenantId && firstId != null) {
        const newUser = {
          id: firstId,
          email: formData.email,
          firstName: formData.firstName,
          lastName: formData.lastName,
          tenantId: formData.tenantId,
          tenantName: formData.tenantName,
          role: { name: formData.roleName },
          isInactive: false
        };

        onUserCreate(newUser);

        toast.success(`User created successfully with ID: ${firstId}`);
        navigate("/users");
        handleEnvChange(env, formData.tenantId, formData.tenantName);
      }
    } catch (error) {
      toast.error("Failed to create user.");
    }
  };

  return (
    <Container className="mt-1">
      <h4 className="mb-4">Add New User</h4>
      <Card className="border mb-3" style={{ maxHeight: "600px" }}>
        <Card.Body>
          <Form onSubmit={handleSubmit}>
            <UserDetails
              isLoading={isLoading}
              isError={isError}
              tenants={filteredTenants}
              onFormChange={handleFormChange}
              formData={formData}
              env={env}
            />
            <div className="d-grid">
              <Button variant="primary" type="submit" className="mt-3 mb-3 mx-auto" style={{ width: "25%" }} disabled={mutationLoading}>
                {mutationLoading ? "Creating user..." : "Create User"}
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default AddUserPage;
